import {
    ChangeDetectionStrategy,
    Component,
    createNgModule,
    CUSTOM_ELEMENTS_SCHEMA,
    EnvironmentInjector,
    Injectable,
    Injector,
    ModuleWithProviders,
    NgModule,
    Provider,
    Type,
} from '@angular/core';
import {JitComponentClass} from 'app/content/screen/factory/classes/jit-component.class';
import {ScreenInterface} from 'app/content/screen/factory/interfaces/screen.interface';

export interface JitComponentDefinition {
    component: Type<ScreenInterface>;
    injector: EnvironmentInjector;
}

@Injectable()
export class ComponentFactoryFactory {
    constructor(private injector: Injector) {}

    /**
     * Builds a component from a template string at runtime. This relies on the
     * JIT compiler staying in the bundle (angular.json aot: false).
     */
    public create(
        template: string,
        imports: Array<
            Type<unknown> | ModuleWithProviders<{}> | unknown[]
        > = [],
        providers: Provider[] = [],
        componentClass: Type<ScreenInterface> = JitComponentClass
    ): JitComponentDefinition {
        // Eager: the Angular 22 default is OnPush, which this content never opted into
        @Component({
            template,
            standalone: false,
            changeDetection: ChangeDetectionStrategy.Eager,
        })
        class JitTemplateComponent extends componentClass {}

        @NgModule({
            schemas: [CUSTOM_ELEMENTS_SCHEMA],
            declarations: [JitTemplateComponent],
            imports,
            providers,
        })
        class JitTemplateModule {}

        return {
            component: JitTemplateComponent,
            injector: createNgModule(JitTemplateModule, this.injector).injector,
        };
    }
}
